import React from "react";
import { isEmbedded } from "src/utils/appBridgeInit";
import DashboardSkeleton from "./DashboardSkeleton";

/** Minimal sidebar chrome for standalone boot — gray only. */
const SidebarSkeleton = () => (
  <aside
    style={{
      width: 156,
      minWidth: 156,
      borderRight: "1px solid #e1e3e5",
      background: "#fff",
      padding: "12px 10px",
      boxSizing: "border-box",
    }}
  >
    <div style={{ width: "100%", height: 18, borderRadius: 4, background: "#e1e3e5", marginBottom: 16 }} />
    {Array.from({ length: 9 }, (_, i) => (
      <div
        key={i}
        style={{
          width: i === 0 ? "100%" : `${78 - (i % 3) * 6}%`,
          height: 14,
          borderRadius: 4,
          background: "#eceef0",
          marginBottom: 10,
        }}
      />
    ))}
  </aside>
);

/** Route-level / app-boot dashboard loading UI — matches live layout, LCP-light. */
export const DashboardLoadingShell: React.FC = () => {
  const embedded = isEmbedded();

  if (embedded) {
    return (
      <div role="status" aria-live="polite" aria-label="Loading dashboard">
        <DashboardSkeleton />
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading dashboard"
      style={{
        minHeight: "100vh",
        display: "flex",
        background: "#f6f6f7",
      }}
    >
      <SidebarSkeleton />
      <div style={{ flex: 1, minWidth: 0, padding: 8, boxSizing: "border-box" }}>
        <DashboardSkeleton />
      </div>
    </div>
  );
};

export default DashboardLoadingShell;
